var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcStatementHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 26,
    viewBox: "0 0 33 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.8999 25H26.8999C28.0934 25 29.238 24.5259 30.0819 23.682C30.9258 22.8381 31.3999 21.6935 31.3999 20.5V5.5C31.3999 4.30653 30.9258 3.16193 30.0819 2.31802C29.238 1.47411 28.0934 1 26.8999 1H5.8999C4.70643 1 3.56184 1.47411 2.71792 2.31802C1.87401 3.16193 1.3999 4.30653 1.3999 5.5V20.5C1.3999 21.6935 1.87401 22.8381 2.71792 23.682C3.56184 24.5259 4.70643 25 5.8999 25Z",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 7H25.3999",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 13H25.3999",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8999 19H25.3999",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 7H17.8999",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 13H17.8999",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3999 19H17.8999",
    stroke: "#2C4C8F",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcStatementHistory);
export default __webpack_public_path__ + "static/media/ic_statement_history.636cf1e0ecb319e8c14f2f10e6d6f2fc.svg";
export { ForwardRef as ReactComponent };